import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/intel/Layout";
import { useInvestigations } from "@/lib/intel/store";
import { EvidenceTimeline } from "@/components/intel/EvidenceTimeline";
import { Clock } from "lucide-react";

export const Route = createFileRoute("/timeline")({
  head: () => ({ meta: [{ title: "Timeline · CARIO INTEL" }] }),
  component: TimelinePage,
});

function TimelinePage() {
  const { state } = useInvestigations();
  const events = [
    ...state.custody.map((c) => ({
      kind: "run" as const,
      ts: c.ts,
      title: `${c.action.replace(/_/g, " ")} · ${c.detail ?? ""}`,
      source: c.actor,
      severity: "low" as const,
      category: "run" as const,
      precision: "day" as const,
    })),
    ...(state.lastScan?.timeline ?? []),
  ];

  return (
    <AppLayout>
      <div className="p-3 space-y-3">
        <div className="glass rounded-xl p-4 flex items-center gap-3">
          <Clock className="h-4 w-4 text-cyan" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan">Unified timeline</div>
            <h1 className="font-display text-2xl">Investigation chronology</h1>
          </div>
          <div className="ml-auto font-mono text-[10px] text-muted-foreground">{events.length} events</div>
        </div>
        <div className="glass rounded-xl p-5">
          <EvidenceTimeline
            events={events}
            emptyLabel="No dated evidence yet. Run a scan or open a case from the command dashboard."
          />
        </div>
      </div>
    </AppLayout>
  );
}